import { Grid, Typography } from '@mui/material';
import { SelectElement } from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { AutoOpenFragmentMode } from '../../../stores/stream-screen-settings.store';

export function AutoOpenFragmentField() {
  const { $t } = useIntl();

  const optionAutoOpenNever = {
    id: AutoOpenFragmentMode.NEVER,
    name: $t({
      id: 'logger.streamScreen.autoOpenFragment.never',
      defaultMessage: 'Nunca',
    }),
  };
  const optionAutoOpenStartOrEnd = {
    id: AutoOpenFragmentMode.ON_START_OR_END,
    name: $t({
      id: 'logger.streamScreen.autoOpenFragment.onStartOrEnd',
      defaultMessage: 'Al marcar inicio o fin',
    }),
  };
  const optionAutoOpenStartAndEnd = {
    id: AutoOpenFragmentMode.ON_START_AND_END,
    name: $t({
      id: 'logger.streamScreen.autoOpenFragment.onStartAndEnd',
      defaultMessage: 'Al marcar inicio y fin',
    }),
  };

  return (
    <>
      <Grid item xs={12} md={6}>
        <Typography>
          <FormattedMessage
            id="logger.streamScreen.screenSettings.autoOpenFragment"
            defaultMessage="Abrir creación de fragmento al seleccionar (en modo default)"
          />
        </Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <SelectElement
          name="autoOpenFragmentMode"
          label=""
          options={[
            {
              id: optionAutoOpenNever.id,
              label: optionAutoOpenNever.name,
            },
            {
              id: optionAutoOpenStartOrEnd.id,
              label: optionAutoOpenStartOrEnd.name,
            },
            {
              id: optionAutoOpenStartAndEnd.id,
              label: optionAutoOpenStartAndEnd.name,
            },
          ]}
          valueKey="id"
          labelKey="label"
          fullWidth
        />
      </Grid>
    </>
  );
}
